import { AssignStripeSubscriptionRequestSchema, AssignStripeSubscriptionResponseSchema, BaseResponseSchema, CreateStripePriceRequestSchema, CreateStripePriceResponseSchema, CreateStripeProductRequestSchema, ListStripeProductsRequestSchema, ListStripeProductsResponseSchema, ListStripeSubscriptionsRequestSchema, ListStripeSubscriptionsResponseSchema, SingleStripeProductResponseSchema, StripePriceIdParamSchema, StripeProductIdParamSchema, UpdateStripeProductRequestSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider/stripe/`. */
export const providerStripeContract = {
    assignSubscription: {
        method: 'POST',
        path: '/provider/stripe/subscriptions/assign',
        body: AssignStripeSubscriptionRequestSchema,
        response: AssignStripeSubscriptionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to assign Stripe subscription',
    },
    listSubscriptions: {
        method: 'GET',
        path: '/provider/stripe/subscriptions',
        query: ListStripeSubscriptionsRequestSchema,
        response: ListStripeSubscriptionsResponseSchema,
        responseStyle: 'unwrap-data',
        queryLimitMax: 100,
        errorMessage: 'Failed to list Stripe subscriptions',
    },
    createProduct: {
        method: 'POST',
        path: '/provider/stripe/products',
        body: CreateStripeProductRequestSchema,
        response: SingleStripeProductResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create Stripe product',
    },
    listProducts: {
        method: 'GET',
        path: '/provider/stripe/products',
        query: ListStripeProductsRequestSchema,
        response: ListStripeProductsResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 100,
        errorMessage: 'Failed to list Stripe products',
    },
    getProductById: {
        method: 'GET',
        path: '/provider/stripe/products/:productId',
        pathParams: StripeProductIdParamSchema,
        response: SingleStripeProductResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get Stripe product',
    },
    updateProduct: {
        method: 'PUT',
        path: '/provider/stripe/products/:productId',
        pathParams: StripeProductIdParamSchema,
        body: UpdateStripeProductRequestSchema,
        response: SingleStripeProductResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update Stripe product',
    },
    archiveProduct: {
        method: 'DELETE',
        path: '/provider/stripe/products/:productId',
        pathParams: StripeProductIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to archive Stripe product',
    },
    createPrice: {
        method: 'POST',
        path: '/provider/stripe/products/:productId/prices',
        pathParams: StripeProductIdParamSchema,
        body: CreateStripePriceRequestSchema,
        response: CreateStripePriceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create Stripe price',
    },
    deactivatePrice: {
        method: 'PUT',
        path: '/provider/stripe/products/prices/:priceId/deactivate',
        pathParams: StripePriceIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to deactivate Stripe price',
    },
};
//# sourceMappingURL=provider-stripe.contract.js.map